<!-- progress bar starts -->
<div class= "background-style">

  <div class="progress ie-padding">
    <div class="circle done"> <span class="label">1</span>
        <p class="title-span-1">Site</p>

  </div> <span class="bar"><span class=" bar-done "></span></span>

  <div class="circle done"> <span class="label">2</span>
        <p class="title-span-2">ERG</p>
    </div> <span class="bar"><span class=" bar-done"></span></span>

  <div class="circle done"> <span class="label">3</span>
        <p class="title-span-3 ie-span-3">Areas of Impact</p>

  </div> <span class="bar"><span class=" bar-done "></span></span>


  <div class="circle done"> <span class="label">4</span>
        <p class="title-span-4">Skills/interests</p>
    </div> <span class="bar"><span class=" bar-done "></span></span>
    <div class="circle done"> <span class="label">5</span>
        <p class="title-span-5">Leadership</p>
  </div>
</div>
<!-- progress bar ends -->

<!-- membership Leadership starts -->
<div class="div">
  <div class="heading">
    If interested in serving an ERG leadership position, which role would you be willing to serve?
  </div>
  <div class="form font-family">
    <div class="col-md-12 col-md-4 leadership-space">
      <span class="col-md-4 radio_value">Chair</span> 
      <input class="radio-align" type="radio" name="chair"  [value]="true"  [(ngModel)]="chair"/> Yes
      <input class="radio-align" type="radio" name="chair"  [value]="false"  [(ngModel)]="chair" /> No
    </div>
    <div class="col-md-12 col-md-4 leadership-space">
      <span class="col-md-4 radio_value">Vice Chair</span>
      <input class="radio-align" type="radio" name="Voice" [value]="true"  [(ngModel)]="voiceChair" /> Yes
      <input class="radio-align" type="radio" name="Voice" [value]="false"  [(ngModel)]="voiceChair" /> No
    </div>
    <div class="col-md-12 col-md-4 leadership-space">
      <span class="col-md-4 radio_value">Communications Chair</span>
      <input class="radio-align" type="radio" name="Communications" [value]="true"  [(ngModel)]="communicationsChair" /> Yes
      <input class="radio-align" type="radio" name="Communications" [value]="false"  [(ngModel)]="communicationsChair" /> No
    </div>
    <div class="col-md-12 col-md-4 leadership-space">
      <span class="col-md-4 radio_value"> Finance Chair </span>
      <input class="radio-align" type="radio" name="Finance" [value]="true"  [(ngModel)]="financeChair"/> Yes
      <input class="radio-align" type="radio" name="Finance" [value]="false"  [(ngModel)]="financeChair" /> No
    </div>
  </div>

  <p class="top-space text-center bottom-class margin-bottom">
    
    
    <button class="radio-align" type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button" (click)="redirectToBpg()" routerLink='../skills'>BACK</button>
    <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button" (click)="saveData()" routerLink='../preview'>PREVIEW</button>
    <button class="radio-align" type="button" class="btn btn-link button-position font-family-skip" (click)="skipLeadership()" routerLink='../preview'> Skip Form ></button>
  </p>
</div>
</div>
<!-- membership Leadership ends -->
